<template>
<el-dialog  title="修改" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="xiugaiSGFlag" width="95%" center>
  <div>
    <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
    <div class="box3">
      <p class="box31">订单号：{{rowData.orderNo}}</p>
      <p class="box31">外部单号：{{rowData.externalOrderNumber?rowData.externalOrderNumber:'-'}}</p>
      <el-form-item label="项目名称:" prop="projectType"   >
        <el-select  v-model="goodform.projectType" filterable  placeholder="请选择" >
          <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
    </div>
    <hr>
    <div style="margin-top:20px;display: flex;justify-content: space-between;" class="addressBox" >
      <h4 class="title">
        <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
      </h4>
      <div>合计：<span>{{rowData.productTypeName}}/</span>
              <span class="red">{{goodform.allWeight}}</span>吨/
              <span class="red">{{goodform.allNumber}}</span>件
            </div>
    </div>
    <div class="btnRow">
      <el-button type="primary" size="mini" @click="guanlianFN">加货</el-button>
      <div class="locateBox">
        <el-input class="locateInput" size="mini" v-model="locateBarcode" placeholder="输入捆包号定位" clearable
          @keyup.enter.native="locateGoods" @clear="clearLocate"></el-input>
        <el-button type="primary" size="mini" plain @click="locateGoods">定位</el-button>
      </div>
    </div>
    <el-table height="300px" size="mini" ref="tabref" :data="goodsList" style="width:100%" border center>
      <el-table-column type="index"  label="序号" width="60"></el-table-column>
      <el-table-column label="操作"  width="100">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" v-if="scope.row.orderGoodsState!=1" @click="delFn(scope.$index)">删除</el-button>
              <span v-else>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderGoodsState" label="生成运单">
          <template scope="scope">
            <div>
             <span>{{['否','是'][scope.row.orderGoodsState]}}</span>
            </div>
          </template>
        </el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
        width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)" align="center"
          width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"
          width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位" align="center"
          width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="100"
        align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
        width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center"
        width="230"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center"
        width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center"
        width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unloadingSite" label="卸点" align="center"
        min-width="250"></el-table-column>
    </el-table>
    <div style="margin-top:20px" class="addressBox" >
      <h4 class="title">
        <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>人车信息</span>
      </h4>
    </div>
    <renchexinxiSG :goodform="goodform" :show-locate="true"></renchexinxiSG>
  </el-form>
  <el-dialog title="关联货物" :visible.sync="addVisible" :close-on-click-modal="false" width="90%"
      center append-to-body>
      <!--输入框-->
      <div class="guanLianBox-input">
        <el-form :inline="true" :model="formData" class="demo-form-inline" size="mini"  ref="formData">
          <div class="box">
            <el-form-item label="捆包号:" class="item1">
              <el-input type="textarea" v-model="formData.cargoBarcodes" placeholder="请输入" size="mini"
                style="width:150px;vertical-align:top;"></el-input>
            </el-form-item>
            <el-form-item label="卸点:">
              <el-input placeholder="" v-model="formData.unloadingSite" ></el-input>
            </el-form-item>
             <el-form-item label="合约号:">
              <el-input v-model="formData.agreementNumber" placeholder="请输入" size="mini" style="width:135px;"></el-input>
            </el-form-item>
            <el-form-item label="宽度:">
              <el-select size="mini" v-model="formData.widthWhere" placeholder="请选择" style="width:120px;">
                <el-option label="全部" value=""></el-option>
                <el-option label="大于等于" value="1"></el-option>
                <el-option label="小于等于" value="3"></el-option>
                <el-option label="等于" value="2"></el-option>
              </el-select>
              <el-input v-model="formData.width" v-number-input.float="0" placeholder="请输入" size="mini"
                style="width:80px;"></el-input>
            </el-form-item>
          </div>
          <div class="searchBtnBox">
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi">重置</el-button>
          </div>
        </el-form>
      </div>
      <div class="guanLianBox-Table">
        <el-table size="mini" ref="guanlianTable" :data="relevanceTableData" style="width:100%" height="40vh"
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"  @row-click="handleRowClick" border center
          bordersize="mini">
          <el-table-column type="selection" align="center" fixed width="60" :selectable="checkSelectable"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
          width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="unloadingSite" label="卸点" align="center"
            min-width="250"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"
            align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
            width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center"
              min-width="160"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)" align="center"
            width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="货位" align="center" width="100">
              <template slot-scope="scope">
                <div>
                  <span>{{ scope.row.warehouseName }}</span>
                  <span v-if='scope.row.locationName'>-{{ scope.row.locationName }}</span>
                  <span v-if='scope.row.binName'>-{{ scope.row.binName }}</span>
                </div>
              </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center"
              min-width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center"
              min-width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"
              min-width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="入库车号" align="center"
                min-width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createTime" label="入库时间"  align="center"
                width="180"></el-table-column>
        </el-table>
        <!--分页-->
        <div class="pags" style="text-align: right;">
          <el-pagination background @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize"
            :page-sizes="[10, 50, 100, 500]" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange" :total="total"></el-pagination>
        </div>
      </div>
      <div style="width:158px;margin:20px auto;">
        <el-button @click="addVisible=false">取消</el-button>
        <el-button type="primary" @click="guanlianOk" >确定</el-button>
      </div>
    </el-dialog>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button  @click="closeDialog">取消</el-button>
    <el-button type="primary" @click="saveFn">提交</el-button>
  </span>
</el-dialog>
</template>
<script>
import { updateOrderBill, getOrderBill, getWMSGoodsPlus, getDictionaryDetailList } from '@/api/newTMS'
import { formatterRowEmpty, toFixed } from '@/utils/util'
import renchexinxiSG from '@/views/newTMS/publicFiles/orderManage/renchexinxiSG.vue'
export default {
  name: 'xiugaiSG',
  components: {
    renchexinxiSG
  },
  props: {
    xiugaiSGFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      goodsList: [],
      goodform: { billCarriers: [], measuringUnit: '吨', orderWeight: this.rowData.orderWeight, deleteCarrierRelIds: [] },
      rules: {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        orderBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        orderWeight: [
          { required: true, message: '请输入货量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择要求到达时间', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ]
      },
      delgoods: [],
      addVisible: false, // 加货
      pageNo: 1,
      pageSize: 50,
      formData: { cargoBarcodes: '' },
      total: 0,
      relevanceTableData: [],
      XMlist: [],
      locateBarcode: '' // 捆包号定位关键字
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })

    // 计算自由车加个需要的值
    this.$set(this.goodform, 'productTypeName', this.rowData.productTypeName)
    this.$set(this.goodform, 'startDirection', this.rowData.startDirection)
    this.$set(this.goodform, 'endDirection', this.rowData.endDirection)
    this.$set(this.goodform, 'payee', this.rowData.payee)

    this.$set(this.goodform, 'projectType', this.rowData.projectType)
    getOrderBill({ orderId: this.rowData.orderId }).then(res => {
      this.goodform.billCarriers = res.carrierList
      this.goodsList = res.goodList
      this.getAllWeight()
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })
  },
  methods: {
    delFn (index) {
      if (this.goodsList[index].goodsId) {
        this.delgoods.push(this.goodsList[index].goodsId)
      }
      this.goodsList.splice(index, 1)
      this.getAllWeight()
    },
    saveFn () {
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          let arr = []
          this.goodform.billCarriers.forEach(item => {
            if (!item.id) {
              arr.push(item)
            }
          })
          let arrgood = []
          this.goodsList.forEach(item => {
            if (!item.goodsId) {
              arrgood.push(item)
            }
          })
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateOrderBill({
            orderId: this.rowData.orderId,
            orderBusinessId: this.rowData.orderBusinessId,
            addGoods: arrgood,
            deleteGoods: this.delgoods,
            addCarriers: arr,
            deleteCarrierRelIds: this.goodform.deleteCarrierRelIds,
            projectType: this.goodform.projectType
          }).then(res => {
            loading.close()
            this.$emit('update:xiugaiSGFlag', false)
            this.$parent.searchFn()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 计算货物重量
    getAllWeight () {
      this.allWeight = 0
      let allNumber = 0
      this.goodsList.forEach(item => {
        if (item.weight) {
          this.allWeight = (this.allWeight * 1000 + item.weight * 1000) / 1000
        }
        if (item.number) {
          allNumber = (allNumber * 1000 + item.number * 1000) / 1000
        }
      })
      this.$set(this.goodform, 'allWeight', toFixed(this.allWeight, 3))
      this.$set(this.goodform, 'allNumber', allNumber)
    },
    // 加货
    guanlianFN () {
      this.addVisible = true
      this.chaxun()
    },
    guanlianOk () {
      let selectData = this.$refs.guanlianTable.selection
      let arr = []
      selectData.forEach(item => {
        item.orderGoodsState = 0
        arr.push(item)
      })
      this.goodsList = this.goodsList.concat(arr)
      this.getAllWeight()
      this.addVisible = false
    },
    // 选择数据
    selectGoods (selection) {
    },
    handleRowClick (row, column, event) {
      let json = this.goodsList.filter(i => i.cargoBarcode == row.cargoBarcode)
      if (json.length == 0) {
        this.$refs.guanlianTable.toggleRowSelection(row)
      }
    },
    checkSelectable (row) {
      let json = this.goodsList.filter(i => i.cargoBarcode == row.cargoBarcode)
      if (json.length == 0) {
        return true
      } else {
        return false
      }
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.chaxun()
    },
    chaxun () {
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.replace(/\n/g, ',')
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.split(',').filter(item => item != '').join(',')
      getWMSGoodsPlus(
        {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          customerName: '中物唐山曹妃甸区物流有限责任公司',
          productTypeName: this.rowData.productTypeName,
          matchStatus: 1,
          ...this.formData
        }
      ).then(res => {
        this.relevanceTableData = res.pageInfo.list
        this.total = res.pageInfo.total
      }).catch(error => {
        this.$message({ message: error.message, type: 'error' })
      })
    },
    chongzhi () {
      this.formData = {
        cargoBarcodes: '',
        specification: '',
        steelMillName: '',
        widthWhere: '',
        width: '',
        model: ''
      }
      this.chaxun()
    },
    //= ========关联货物结束==========
    // 捆包号定位
    locateGoods () {
      this.doLocate('tabref', this.goodsList, ['cargoBarcode'], this.locateBarcode, '捆包号')
    },
    clearLocate () {
      this.clearLocateHighlight('tabref')
    },
    // 通用定位：tableRef 表格ref，list 表格数据，props 参与匹配的字段，keyword 关键字（支持逗号/空格分隔多个）
    doLocate (tableRef, list, props, keyword, label) {
      const table = this.$refs[tableRef]
      if (!table) return
      const keys = (keyword || '').split(/[,，\s]+/).filter(item => item)
      if (!keys.length) {
        this.$message({ message: '请输入' + label + '后再定位', type: 'warning' })
        return
      }
      const wrapper = table.$el.querySelector('.el-table__body-wrapper')
      const rows = wrapper ? wrapper.querySelectorAll('tbody > tr') : []
      const indexs = []
      list.forEach((item, index) => {
        const hit = props.some(prop => {
          const val = item[prop] === null || item[prop] === undefined ? '' : String(item[prop]).toUpperCase()
          return val && keys.some(key => val.indexOf(key.toUpperCase()) > -1)
        })
        if (hit) indexs.push(index)
      })
      // 先清掉上一次的高亮
      this.clearLocateHighlight(tableRef)
      if (!indexs.length) {
        this.$message({ message: '未找到该' + label, type: 'warning' })
        return
      }
      indexs.forEach(index => {
        if (rows[index]) rows[index].classList.add('locate-highlight')
      })
      // 滚动到第一个匹配行
      const firstRow = rows[indexs[0]]
      if (wrapper && firstRow) {
        const wrapperRect = wrapper.getBoundingClientRect()
        const rowRect = firstRow.getBoundingClientRect()
        const top = wrapper.scrollTop + (rowRect.top - wrapperRect.top) - wrapper.clientHeight / 2 + rowRect.height / 2
        wrapper.scrollTop = top > 0 ? top : 0
      }
      // 5 秒后自动取消高亮
      clearTimeout(this.locateTimer)
      this.locateTimer = setTimeout(() => {
        this.clearLocateHighlight(tableRef)
      }, 5000)
    },
    clearLocateHighlight (tableRef) {
      const table = this.$refs[tableRef]
      if (!table) return
      const rows = table.$el.querySelectorAll('.el-table__body-wrapper tbody > tr')
      rows.forEach(item => item.classList.remove('locate-highlight'))
    },
    closeDialog () {
      this.$emit('update:xiugaiSGFlag', false)
    }

  }

}
</script>

<style scoped lang='less'>
.box3{
  display: flex;
  flex-wrap:wrap;
  .box31{
    min-width: 300px;
  }
  p{
    margin-right: 20px;
    margin-top: 0;
  }
}
.btnRow{
  display: flex;
  align-items: center;
}
.locateBox{
  display: flex;
  align-items: center;
  margin-left: 12px;
  .locateInput{
    width: 200px;
    margin-right: 8px;
  }
}
/* 定位命中的行高亮 */
/deep/ .el-table__body tbody > tr.locate-highlight > td{
  background-color: #ffe58f !important;
}
</style>
